import React, { useEffect, useMemo, useState } from 'react';
import { Badge, Form } from 'react-bootstrap';
import { PageBusyLoader } from '../ui/PageBusyLoader';
import { Calculator, InfoCircleFill } from 'react-bootstrap-icons';
import { useSessionStore } from '../../store/sessionStore';
import AppBackButton from '../common/AppBackButton';
import './NegotiatorCenter.css';

type TierKey = 'low' | 'lowMid' | 'medium' | 'medHigh' | 'high';

type StateMeta = {
  name: string;
  gasPrice: number;
  tier: TierKey;
  payMarketIndex: number;
};

const STATE_DATA: Record<string, StateMeta> = {
  AL: {
    name: 'Alabama',
    gasPrice: 3.841,
    tier: 'lowMid',
    payMarketIndex: 0.97,
  },
  AK: { name: 'Alaska', gasPrice: 4.866, tier: 'high', payMarketIndex: 1.08 },
  AZ: { name: 'Arizona', gasPrice: 4.632, tier: 'high', payMarketIndex: 1.06 },
  AR: { name: 'Arkansas', gasPrice: 3.744, tier: 'low', payMarketIndex: 0.96 },
  CA: {
    name: 'California',
    gasPrice: 5.983,
    tier: 'high',
    payMarketIndex: 1.25,
  },
  CO: {
    name: 'Colorado',
    gasPrice: 4.193,
    tier: 'medHigh',
    payMarketIndex: 1.07,
  },
  CT: {
    name: 'Connecticut',
    gasPrice: 4.283,
    tier: 'medHigh',
    payMarketIndex: 1.09,
  },
  DE: {
    name: 'Delaware',
    gasPrice: 4.146,
    tier: 'medium',
    payMarketIndex: 1.02,
  },
  FL: {
    name: 'Florida',
    gasPrice: 4.153,
    tier: 'medium',
    payMarketIndex: 1.03,
  },
  GA: {
    name: 'Georgia',
    gasPrice: 3.702,
    tier: 'lowMid',
    payMarketIndex: 0.99,
  },
  HI: { name: 'Hawaii', gasPrice: 5.634, tier: 'high', payMarketIndex: 1.15 },
  ID: { name: 'Idaho', gasPrice: 4.404, tier: 'high', payMarketIndex: 1.02 },
  IL: { name: 'Illinois', gasPrice: 4.527, tier: 'high', payMarketIndex: 1.05 },
  IN: {
    name: 'Indiana',
    gasPrice: 4.092,
    tier: 'medium',
    payMarketIndex: 0.99,
  },
  IA: { name: 'Iowa', gasPrice: 3.835, tier: 'low', payMarketIndex: 0.97 },
  KS: { name: 'Kansas', gasPrice: 3.703, tier: 'low', payMarketIndex: 0.96 },
  KY: {
    name: 'Kentucky',
    gasPrice: 4.067,
    tier: 'medium',
    payMarketIndex: 0.97,
  },
  LA: {
    name: 'Louisiana',
    gasPrice: 3.77,
    tier: 'lowMid',
    payMarketIndex: 0.97,
  },
  ME: { name: 'Maine', gasPrice: 4.213, tier: 'medHigh', payMarketIndex: 1.02 },
  MD: {
    name: 'Maryland',
    gasPrice: 4.191,
    tier: 'medHigh',
    payMarketIndex: 1.08,
  },
  MA: {
    name: 'Massachusetts',
    gasPrice: 4.113,
    tier: 'medium',
    payMarketIndex: 1.14,
  },
  MI: {
    name: 'Michigan',
    gasPrice: 4.257,
    tier: 'medHigh',
    payMarketIndex: 1.0,
  },
  MN: {
    name: 'Minnesota',
    gasPrice: 3.93,
    tier: 'lowMid',
    payMarketIndex: 1.01,
  },
  MS: {
    name: 'Mississippi',
    gasPrice: 3.747,
    tier: 'low',
    payMarketIndex: 0.95,
  },
  MO: {
    name: 'Missouri',
    gasPrice: 3.796,
    tier: 'lowMid',
    payMarketIndex: 0.97,
  },
  MT: { name: 'Montana', gasPrice: 4.035, tier: 'lowMid', payMarketIndex: 1.0 },
  NE: {
    name: 'Nebraska',
    gasPrice: 3.842,
    tier: 'lowMid',
    payMarketIndex: 0.97,
  },
  NV: { name: 'Nevada', gasPrice: 5.099, tier: 'high', payMarketIndex: 1.07 },
  NH: {
    name: 'New Hampshire',
    gasPrice: 4.116,
    tier: 'medium',
    payMarketIndex: 1.04,
  },
  NJ: {
    name: 'New Jersey',
    gasPrice: 4.218,
    tier: 'medHigh',
    payMarketIndex: 1.1,
  },
  NM: {
    name: 'New Mexico',
    gasPrice: 3.941,
    tier: 'lowMid',
    payMarketIndex: 0.98,
  },
  NY: {
    name: 'New York',
    gasPrice: 4.24,
    tier: 'medHigh',
    payMarketIndex: 1.18,
  },
  NC: {
    name: 'North Carolina',
    gasPrice: 4.004,
    tier: 'lowMid',
    payMarketIndex: 1.0,
  },
  ND: {
    name: 'North Dakota',
    gasPrice: 3.782,
    tier: 'low',
    payMarketIndex: 0.98,
  },
  OH: { name: 'Ohio', gasPrice: 4.221, tier: 'medHigh', payMarketIndex: 0.99 },
  OK: { name: 'Oklahoma', gasPrice: 3.658, tier: 'low', payMarketIndex: 0.96 },
  OR: { name: 'Oregon', gasPrice: 5.119, tier: 'high', payMarketIndex: 1.08 },
  PA: {
    name: 'Pennsylvania',
    gasPrice: 4.316,
    tier: 'medHigh',
    payMarketIndex: 1.03,
  },
  RI: {
    name: 'Rhode Island',
    gasPrice: 4.141,
    tier: 'medium',
    payMarketIndex: 1.04,
  },
  SC: {
    name: 'South Carolina',
    gasPrice: 3.882,
    tier: 'lowMid',
    payMarketIndex: 0.97,
  },
  SD: {
    name: 'South Dakota',
    gasPrice: 3.863,
    tier: 'lowMid',
    payMarketIndex: 0.97,
  },
  TN: {
    name: 'Tennessee',
    gasPrice: 3.913,
    tier: 'lowMid',
    payMarketIndex: 0.98,
  },
  TX: { name: 'Texas', gasPrice: 3.781, tier: 'lowMid', payMarketIndex: 1.0 },
  UT: { name: 'Utah', gasPrice: 4.308, tier: 'medHigh', payMarketIndex: 1.04 },
  VT: {
    name: 'Vermont',
    gasPrice: 4.189,
    tier: 'medium',
    payMarketIndex: 1.03,
  },
  VA: {
    name: 'Virginia',
    gasPrice: 4.09,
    tier: 'medium',
    payMarketIndex: 1.05,
  },
  WA: {
    name: 'Washington',
    gasPrice: 5.539,
    tier: 'high',
    payMarketIndex: 1.13,
  },
  WV: {
    name: 'West Virginia',
    gasPrice: 4.065,
    tier: 'medium',
    payMarketIndex: 0.96,
  },
  WI: {
    name: 'Wisconsin',
    gasPrice: 3.96,
    tier: 'lowMid',
    payMarketIndex: 0.99,
  },
  WY: { name: 'Wyoming', gasPrice: 3.98, tier: 'lowMid', payMarketIndex: 0.99 },
};

const FOOD_VALUES: Record<TierKey, number> = {
  low: 3500,
  lowMid: 4250,
  medium: 5000,
  medHigh: 5750,
  high: 6500,
};

const TIER_LABELS: Record<TierKey, string> = {
  low: 'Low',
  lowMid: 'Low-Middle',
  medium: 'Medium',
  medHigh: 'Medium-High',
  high: 'High',
};

type ExperienceId =
  | 'beginner'
  | 'fewYears'
  | 'substantialNew'
  | 'intermediate'
  | 'experienced'
  | 'expert';

type RoleFitId = 'none' | 'moderate' | 'strong' | 'exact';

const EXPERIENCE_OPTIONS: {
  id: ExperienceId;
  label: string;
  helper: string;
  bufferPercent: number;
}[] = [
  {
    id: 'beginner',
    label: 'Beginner',
    helper: 'Few years working, but beginner in this field.',
    bufferPercent: 0.09,
  },
  {
    id: 'fewYears',
    label: 'Few years working, but beginner in this field',
    helper: 'Below midpoint to reflect transition risk.',
    bufferPercent: 0.1,
  },
  {
    id: 'substantialNew',
    label: 'Substantial experience, but new in this field',
    helper: 'Above midpoint based on transferable experience.',
    bufferPercent: 0.11,
  },
  {
    id: 'intermediate',
    label: 'Intermediate',
    helper: 'Solid in-field experience and independent execution.',
    bufferPercent: 0.125,
  },
  {
    id: 'experienced',
    label: 'Experienced',
    helper: 'Strong in-field senior execution and leadership.',
    bufferPercent: 0.14,
  },
  {
    id: 'expert',
    label: 'Expert',
    helper: 'High-impact expert who drives business outcomes.',
    bufferPercent: 0.15,
  },
];

const ROLE_FIT_OPTIONS: { id: RoleFitId; label: string; percent: number }[] = [
  { id: 'none', label: 'Not sure / skip', percent: 0 },
  { id: 'moderate', label: 'Moderate Fit', percent: 0.05 },
  { id: 'strong', label: 'Strong Fit', percent: 0.075 },
  { id: 'exact', label: 'Exact Fit', percent: 0.1 },
];

const STATE_NAME_TO_CODE: Record<string, string> = Object.entries(STATE_DATA).reduce(
  (acc, [code, data]) => {
    acc[data.name.toLowerCase()] = code;
    return acc;
  },
  {} as Record<string, string>
);

function currency(value: number): string {
  if (!Number.isFinite(value)) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
}

function percent(value: number): string {
  if (!Number.isFinite(value)) return '0%';
  const pct = value * 100;
  const decimals = Number.isInteger(pct) ? 0 : 1;
  return `${pct.toFixed(decimals)}%`;
}

function normalizeStateCode(value?: string | null): string {
  if (!value) return 'TX';
  const trimmed = String(value).trim();
  const upper = trimmed.toUpperCase();
  if (STATE_DATA[upper]) return upper;
  const fromName = STATE_NAME_TO_CODE[trimmed.toLowerCase()];
  return fromName || 'TX';
}

function getExperienceBase(lower: number, upper: number, experience: ExperienceId): number {
  const midpoint = (lower + upper) / 2;
  switch (experience) {
    case 'beginner':
      return lower * 1.2;
    case 'fewYears':
      return midpoint * 0.9;
    case 'substantialNew':
      return midpoint * 1.1;
    case 'intermediate':
      return midpoint * 1.15;
    case 'experienced':
      return midpoint * 1.25;
    case 'expert':
      return midpoint * 1.35;
    default:
      return midpoint;
  }
}

function getRoleFitBoost(midpoint: number, fit: RoleFitId): number {
  const selected = ROLE_FIT_OPTIONS.find((item) => item.id === fit);
  return midpoint * (selected?.percent || 0);
}

function getSalaryBasedBufferPercent(subtotal: number): number {
  if (subtotal < 100000) return 0.1;
  if (subtotal <= 200000) return 0.135;
  return 0.1;
}

function getExperienceBufferPercent(experience: ExperienceId): number {
  return EXPERIENCE_OPTIONS.find((item) => item.id === experience)?.bufferPercent || 0.12;
}

function getAdaptiveNegotiationBufferPercent(subtotal: number, experience: ExperienceId): number {
  const salaryBased = getSalaryBasedBufferPercent(subtotal);
  const experienceBased = getExperienceBufferPercent(experience);
  return (salaryBased + experienceBased) / 2;
}

function getLocationAdjustmentAmount(
  baseAmount: number,
  profileState: string,
  jobState: string,
  applyLocationAdjustment: boolean
): number {
  if (!applyLocationAdjustment) return 0;
  if (!profileState || !jobState) return 0;
  if (profileState === jobState) return 0;

  const currentIndex = STATE_DATA[profileState]?.payMarketIndex || 1;
  const jobIndex = STATE_DATA[jobState]?.payMarketIndex || 1;
  return baseAmount * (jobIndex - currentIndex);
}

const NegotiatorCenter: React.FC = () => {
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [profileState, setProfileState] = useState('TX');
  const [jobState, setJobState] = useState('TX');

  const [lowerRange, setLowerRange] = useState(130000);
  const [upperRange, setUpperRange] = useState(180000);
  const [experience, setExperience] = useState<ExperienceId>('experienced');
  const [roleFit, setRoleFit] = useState<RoleFitId>('strong');

  const [isRemote, setIsRemote] = useState(false);
  const [oneWayMiles, setOneWayMiles] = useState(20);
  const [officeDaysPerWeek, setOfficeDaysPerWeek] = useState(3);
  const [vehicleMpg, setVehicleMpg] = useState(25);

  const [companyProvidesFood, setCompanyProvidesFood] = useState(true);
  const [applyLocationAdjustment, setApplyLocationAdjustment] = useState(true);
  const [includeNegotiationBuffer, setIncludeNegotiationBuffer] = useState(true);

  useEffect(() => {
    let mounted = true;

    const hydrateFromProfile = async () => {
      try {
        const user =
          useSessionStore.getState().currentUser ??
          (await useSessionStore.getState().bootstrapSession()).user;
        if (!mounted) return;

        const profileStateCode = normalizeStateCode((user as { state?: string })?.state);
        setProfileState(profileStateCode);
        setJobState(profileStateCode);
      } catch (error) {
        console.error('Failed to load profile state for Negotiator Center.', error);
      } finally {
        if (mounted) setLoadingProfile(false);
      }
    };

    hydrateFromProfile();
    return () => {
      mounted = false;
    };
  }, []);

  const stateOptions = useMemo(
    () => Object.entries(STATE_DATA).sort((a, b) => a[1].name.localeCompare(b[1].name)),
    []
  );

  const result = useMemo(() => {
    const safeLower = Number.isFinite(lowerRange) ? Math.max(0, Number(lowerRange)) : 0;
    const safeUpper = Number.isFinite(upperRange) ? Math.max(0, Number(upperRange)) : 0;

    const lower = Math.min(safeLower, safeUpper || safeLower);
    const upper = Math.max(safeLower, safeUpper || safeLower);
    const midpoint = (lower + upper) / 2;

    const profileStateInfo = STATE_DATA[profileState] || STATE_DATA.TX;

    const experienceBase = getExperienceBase(lower, upper, experience);
    const roleFitBoost = getRoleFitBoost(midpoint, roleFit);

    const mpg = Math.max(1, Number(vehicleMpg) || 25);
    const miles = Math.max(0, Number(oneWayMiles) || 0);
    const officeDays = Math.max(0, Math.min(7, Number(officeDaysPerWeek) || 0));

    const rawCommuteCost = isRemote
      ? 0
      : ((miles * 2 * officeDays * 52) / mpg) * profileStateInfo.gasPrice;
    const cappedCommuteCost = Math.min(rawCommuteCost, 12000);
    const effectiveCommuteCost = cappedCommuteCost * 0.5;

    const rawFoodBenefitValue = companyProvidesFood ? FOOD_VALUES[profileStateInfo.tier] : 0;
    const effectiveFoodBenefitValue = rawFoodBenefitValue * 0.6;

    const locationAdjustment = getLocationAdjustmentAmount(
      experienceBase + roleFitBoost,
      profileState,
      jobState,
      applyLocationAdjustment
    );

    const subtotalBeforeBuffer =
      experienceBase +
      roleFitBoost +
      locationAdjustment -
      effectiveCommuteCost -
      effectiveFoodBenefitValue;

    const adaptiveBufferPercent = getAdaptiveNegotiationBufferPercent(
      subtotalBeforeBuffer,
      experience
    );

    const negotiationBuffer = includeNegotiationBuffer
      ? subtotalBeforeBuffer * adaptiveBufferPercent
      : 0;

    const targetAsk = subtotalBeforeBuffer + negotiationBuffer;
    const safeAsk = targetAsk * 0.95;
    const stretchAsk = targetAsk * 1.1;

    return {
      midpoint,
      profileStateInfo,
      experienceBase,
      roleFitBoost,
      rawCommuteCost,
      cappedCommuteCost,
      effectiveCommuteCost,
      rawFoodBenefitValue,
      effectiveFoodBenefitValue,
      locationAdjustment,
      subtotalBeforeBuffer,
      adaptiveBufferPercent,
      negotiationBuffer,
      safeAsk,
      targetAsk,
      stretchAsk,
    };
  }, [
    lowerRange,
    upperRange,
    experience,
    roleFit,
    isRemote,
    oneWayMiles,
    officeDaysPerWeek,
    vehicleMpg,
    companyProvidesFood,
    profileState,
    jobState,
    applyLocationAdjustment,
    includeNegotiationBuffer,
  ]);

  return (
    <div className="v1-neg-page">
      <main className="v1-neg-main">
        <div className="v1-neg-toolbar">
          <AppBackButton to="/dashboard" />
        </div>
        <section className="v1-neg-header">
          <div>
            <div className="v1-neg-title-row">
              <h1>Negotiation Center</h1>
              <Badge bg="success-subtle" text="success" className="v1-neg-soon-badge">
                Coming Soon
              </Badge>
            </div>
            <p className="v1-neg-subtitle">
              Estimate your Safe Ask, Target Ask, and Stretch Ask before interview and offer
              conversations.
            </p>
          </div>
          <div className="v1-neg-note">
            <div className="v1-neg-note-head">
              <InfoCircleFill /> Methodology note
            </div>
            <p>
              This is an early-access estimator. Values are directional and should be used as
              guidance, not compensation guarantees.
            </p>
          </div>
        </section>

        {loadingProfile ? (
          <PageBusyLoader pageName="Negotiation Center" className="page-busy-loader--compact" />
        ) : null}

        <div className="v1-neg-grid">
          <section className="v1-neg-left">
            <article className="v1-neg-card">
              <h2>
                <span className="v1-neg-step">1</span>
                Posted Salary Range
              </h2>
              <div className="v1-neg-two-col">
                <div>
                  <Form.Label>Minimum salary</Form.Label>
                  <div className="v1-neg-salary-group">
                    <span className="v1-neg-salary-prefix" aria-hidden>
                      $
                    </span>
                    <Form.Control
                      type="number"
                      min={0}
                      value={lowerRange}
                      onChange={(e) => setLowerRange(Number(e.target.value))}
                    />
                  </div>
                </div>
                <div>
                  <Form.Label>Maximum salary</Form.Label>
                  <div className="v1-neg-salary-group">
                    <span className="v1-neg-salary-prefix" aria-hidden>
                      $
                    </span>
                    <Form.Control
                      type="number"
                      min={0}
                      value={upperRange}
                      onChange={(e) => setUpperRange(Number(e.target.value))}
                    />
                  </div>
                </div>
              </div>
              <div className="v1-neg-inline-note">
                Midpoint reference: {currency(result.midpoint)}
              </div>
            </article>

            <article className="v1-neg-card">
              <h2>
                <span className="v1-neg-step">2</span>
                Experience Level
              </h2>
              <div className="v1-neg-option-grid">
                {EXPERIENCE_OPTIONS.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    className={`v1-neg-pill ${experience === item.id ? 'is-selected' : ''}`}
                    onClick={() => setExperience(item.id)}
                  >
                    <strong>{item.label}</strong>
                    <span>{item.helper}</span>
                  </button>
                ))}
              </div>
            </article>

            <article className="v1-neg-card">
              <h2>
                <span className="v1-neg-step">3</span>
                Role Fit
              </h2>
              <div className="v1-neg-fit-grid">
                {ROLE_FIT_OPTIONS.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    className={`v1-neg-fit-btn ${roleFit === item.id ? 'is-selected' : ''}`}
                    onClick={() => setRoleFit(item.id)}
                  >
                    <span>{item.label}</span>
                    <small>+{percent(item.percent)} of midpoint</small>
                  </button>
                ))}
              </div>
            </article>

            <article className="v1-neg-card">
              <h2>
                <span className="v1-neg-step">4</span>
                Work Arrangement and Commute
              </h2>
              <div className="v1-neg-toggle-row">
                <button
                  type="button"
                  className={`v1-neg-toggle ${isRemote ? 'is-active' : ''}`}
                  onClick={() => setIsRemote(true)}
                >
                  Remote
                </button>
                <button
                  type="button"
                  className={`v1-neg-toggle ${!isRemote ? 'is-active' : ''}`}
                  onClick={() => setIsRemote(false)}
                >
                  Hybrid / In-office
                </button>
              </div>

              {!isRemote ? (
                <div className="v1-neg-three-col">
                  <div>
                    <Form.Label>One-way miles</Form.Label>
                    <Form.Control
                      type="number"
                      min={0}
                      value={oneWayMiles}
                      onChange={(e) => setOneWayMiles(Number(e.target.value))}
                    />
                  </div>
                  <div>
                    <Form.Label>Days in office / week</Form.Label>
                    <Form.Control
                      type="number"
                      min={0}
                      max={7}
                      value={officeDaysPerWeek}
                      onChange={(e) => setOfficeDaysPerWeek(Number(e.target.value))}
                    />
                  </div>
                  <div>
                    <Form.Label>Vehicle MPG</Form.Label>
                    <Form.Control
                      type="number"
                      min={1}
                      value={vehicleMpg}
                      onChange={(e) => setVehicleMpg(Number(e.target.value))}
                    />
                  </div>
                </div>
              ) : null}

              <div className="v1-neg-inline-note">
                Profile state gas price ({result.profileStateInfo.name}): $
                {result.profileStateInfo.gasPrice.toFixed(3)} / gallon. Commute impact applies at
                50% and is capped at {currency(12000)} raw annually.
              </div>
            </article>

            <article className="v1-neg-card">
              <h2>
                <span className="v1-neg-step">5</span>
                Free Food Benefit
              </h2>
              <Form.Check
                type="switch"
                id="food-benefit"
                label="Company provides regular free meals or catered food"
                checked={companyProvidesFood}
                onChange={(e) => setCompanyProvidesFood(e.target.checked)}
              />
              <div className="v1-neg-inline-note">
                {result.profileStateInfo.name} tier: {TIER_LABELS[result.profileStateInfo.tier]}.
                Raw value {currency(FOOD_VALUES[result.profileStateInfo.tier])}; applied at 60%.
              </div>
            </article>

            <article className="v1-neg-card">
              <h2>
                <span className="v1-neg-step">6</span>
                Profile Location
              </h2>
              <div className="v1-neg-two-col">
                <div>
                  <Form.Label>Current profile state</Form.Label>
                  <Form.Select
                    value={profileState}
                    onChange={(e) => setProfileState(e.target.value)}
                  >
                    {stateOptions.map(([code, data]) => (
                      <option key={code} value={code}>
                        {data.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div>
                  <Form.Label>Job state</Form.Label>
                  <Form.Select value={jobState} onChange={(e) => setJobState(e.target.value)}>
                    {stateOptions.map(([code, data]) => (
                      <option key={code} value={code}>
                        {data.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>
            </article>

            <article className="v1-neg-card v1-neg-card--compact">
              <h2>
                <span className="v1-neg-step">7</span>
                Location Adjustment
              </h2>
              <Form.Check
                type="switch"
                id="location-adjustment"
                label="Apply location adjustment"
                checked={applyLocationAdjustment}
                disabled={profileState === jobState}
                onChange={(e) => setApplyLocationAdjustment(e.target.checked)}
              />
              <div className="v1-neg-inline-note">
                Uses approximate state-level pay-market indices. Turn off for same-market or fully
                remote contexts.
              </div>
            </article>

            <article className="v1-neg-card v1-neg-card--compact">
              <h2>
                <span className="v1-neg-step">8</span>
                Negotiation Buffer (Adaptive)
              </h2>
              <Form.Check
                type="switch"
                id="buffer-enabled"
                label={`Apply adaptive buffer (${percent(result.adaptiveBufferPercent)})`}
                checked={includeNegotiationBuffer}
                onChange={(e) => setIncludeNegotiationBuffer(e.target.checked)}
              />
              <div className="v1-neg-inline-note">
                Buffer blends salary-level and experience-level percentages for a realistic
                negotiation range.
              </div>
            </article>
          </section>

          <aside className="v1-neg-right">
            <div className="v1-neg-sticky-panel">
              <article className="v1-neg-summary-card">
                <div className="v1-neg-summary-head">
                  <h3>
                    <Calculator />
                    Your Negotiation Range
                  </h3>
                </div>

                <div className="v1-neg-ask-list">
                  <div className="v1-neg-ask safe">
                    <div>
                      <strong>Safe Ask</strong>
                      <span>5% below target</span>
                    </div>
                    <b>{currency(result.safeAsk)}</b>
                  </div>
                  <div className="v1-neg-ask target">
                    <div>
                      <strong>Target Ask</strong>
                      <span>Recommended</span>
                    </div>
                    <b>{currency(result.targetAsk)}</b>
                  </div>
                  <div className="v1-neg-ask stretch">
                    <div>
                      <strong>Stretch Ask</strong>
                      <span>10% above target</span>
                    </div>
                    <b>{currency(result.stretchAsk)}</b>
                  </div>
                </div>

                <h4>10. Calculation Breakdown</h4>
                <div className="v1-neg-breakdown">
                  <div>
                    <span>Experience-adjusted salary</span>
                    <strong>{currency(result.experienceBase)}</strong>
                  </div>
                  <div>
                    <span>Role fit boost</span>
                    <strong>+{currency(result.roleFitBoost)}</strong>
                  </div>
                  <div>
                    <span>Location adjustment</span>
                    <strong>
                      {result.locationAdjustment >= 0 ? '+' : ''}
                      {currency(result.locationAdjustment)}
                    </strong>
                  </div>
                  <div>
                    <span>Raw commute cost</span>
                    <strong>{currency(result.rawCommuteCost)}</strong>
                  </div>
                  <div>
                    <span>Commute impact (50%, capped)</span>
                    <strong>-{currency(result.effectiveCommuteCost)}</strong>
                  </div>
                  <div>
                    <span>Raw food benefit</span>
                    <strong>{currency(result.rawFoodBenefitValue)}</strong>
                  </div>
                  <div>
                    <span>Food impact (60%)</span>
                    <strong>-{currency(result.effectiveFoodBenefitValue)}</strong>
                  </div>
                  <div>
                    <span>Subtotal before buffer</span>
                    <strong>{currency(result.subtotalBeforeBuffer)}</strong>
                  </div>
                  <div>
                    <span>Adaptive buffer {percent(result.adaptiveBufferPercent)}</span>
                    <strong>+{currency(result.negotiationBuffer)}</strong>
                  </div>
                </div>
              </article>

              <article className="v1-neg-summary-card v1-neg-methodology-card">
                <div className="v1-neg-methodology">
                  <h5>11. Methodology Note</h5>
                  <p>
                    Numbers are estimates based on salary band inputs, state-level assumptions, and
                    your selected negotiation posture. Use this to plan your conversation, not as a
                    guaranteed offer outcome.
                  </p>
                </div>
              </article>
            </div>
          </aside>
        </div>
      </main>
    </div>
  );
};

export default NegotiatorCenter;
